// React Thirty Party Library
import { useDispatch } from "react-redux";
import { useState } from "react";
import { EnterOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router";

// Constants Library
import {
  TEMPLATE,
  ROOT_CONSTANT,
  ROUTES,
  COMMON_FEATURES,
} from "../../../../../../constants";

// Components Library
import {
  ButtonLink,
  BtnSubmit,
  TablePagination,
} from "../../../../../../components";

// Handler Librarys

// Redux Actions

// Styles Library
import classes from "../../../../../index.module.css";

const { BTN_IMG } = TEMPLATE.BTN;
const { icon_filter } = ROOT_CONSTANT.IMG.ICON;

const SearchEmployee = (props) => {
  const {
    setIsModalOpen,
    pageSize,
    setPageSize,
    current,
    setCurrent,
    tabKey,
    handlePaginatedDataChange,
    filteredDataCount,
    data,
    setIsOpenAdd,
    setIsOpenAddGroup,
    user,
  } = props;

  const navigate = useNavigate();

  return (
    <>
      <div className={classes.headerPage}>
        <div className={classes.headerWrap}>
          <div className={classes.headerSubStart}>
            <BtnSubmit
              display="inline-block"
              text="Filter"
              bgColor="transparent"
              color="black"
              padding="9px 18px"
              marginTop="2px"
              fontWeight="700"
              border="1px solid #DDDDDD"
              outline="#DDDDDD"
              onClick={() => setIsModalOpen(true)}
              showIcon={true}
              icon={icon_filter}
              icon_alt={"filter"}
              // disable={isFiltered === false && user.uroleid === "A"}
            />
            {/* <ButtonLink style={{ color: "black", marginLeft: "10px" }}>
              <EnterOutlined
                style={{
                  transform: "rotate(180deg)",
                  color: "#0E2483",
                  marginRight: "5px",
                }}
              />
              Assign to employee group
            </ButtonLink> */}
          </div>
          <TablePagination
            tabKey={tabKey}
            data={data}
            filteredDataCount={filteredDataCount}
            onPaginatedDataChange={handlePaginatedDataChange}
            pageSize={pageSize}
            setPageSize={setPageSize}
            current={current}
            setCurrent={setCurrent}
          />
        </div>
        <div className={classes.headerSubEnd}>
         
          <BtnSubmit
            display={"inline-block"}
            text={"Create Employee"}
            bgColor="#0E2483"
            color="white"
            padding="9px 18px"
            marginTop="-2px"
            outline="#0E2483"
            border="1px solid #0E2483"
            onClick={() => {
              setIsOpenAdd(true);
            }}
            showIcon={true}
            icon={BTN_IMG.ADD_WHITE}
            icon_alt={"create"}
            // disable={isFiltered === false && user.uroleid === "A"}
          />
        </div>
      </div>
    </>
  );
};

export default SearchEmployee;
